(function () {
    if (window.__beamAddr) return;
    window.__beamAddr = true;

    var REG = window.BEAM_REG || [];
    var STATE_KEYS = [['arica','AP'],['tarapaca','TA'],['antofagasta','AN'],['atacama','AT'],['coquimbo','CO'],['valparaiso','VS'],['higgins','LI'],['maule','ML'],['nuble','NB'],['biobio','BI'],['bio bio','BI'],['araucania','AR'],['los rios','LR'],['los lagos','LL'],['aysen','AI'],['aisen','AI'],['magallanes','MA'],['metropolitana','RM'],['santiago','RM']];
    var LS_KEY = 'beam-addr-v1';

    var root = document.getElementById('beam-addr');
    if (!root) return;
    document.body.appendChild(root);
    var form = root.querySelector('form');
    var fPhone = form.phone;
    function phoneDigits(v) { return String(v || '').replace(/\D/g, '').replace(/^56(?=\d{9}$)/, ''); }
    var fEmail = form.email, fFirst = form.first_name, fLast = form.last_name, fSave = form.remember;
    var login = document.getElementById('beam-addr-login');
    if (login) login.href = '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search);
    var fStreet = form.street, fExtra = form.extra, fReg = form.region, fCom = form.comuna;
    var sug = root.querySelector('.beam-addr__sug');
    var msg = root.querySelector('.beam-addr__msg');
    var btn = root.querySelector('.beam-addr__go');
    var target = null;      // { type: 'cart' } | { type: 'buy', variant, qty }
    var verified = false;   // dirección elegida de la lista del mapa
    var warned = false;     // ya se avisó que no se pudo confirmar en el mapa
    var results = [], active = -1, timer = null, reqId = 0, shownId = 0;

    function norm(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’']/g, "'").toLowerCase().trim(); }
    /* "Barros Arana 1548" -> { street: "Barros Arana", number: "1548" } (también "#1548", "N° 1548", "S/N") */
    function splitNum(v) {
      var m = String(v || '').trim().match(/^(.*?)[\s,#]+(?:n[°º.]?\s*)?(\d+[a-z]?|s\/?n)$/i);
      return m ? { street: m[1].replace(/[\s,]+$/, ''), number: m[2] } : { street: String(v || '').trim(), number: '' };
    }
    function regionOf(code) { for (var i = 0; i < REG.length; i++) if (REG[i][0] === code) return REG[i]; return null; }
    function stateToCode(state) {
      var s = norm(state);
      for (var i = 0; i < STATE_KEYS.length; i++) if (s.indexOf(STATE_KEYS[i][0]) !== -1) return STATE_KEYS[i][1];
      return '';
    }
    function findComuna(code, names) {
      var r = regionOf(code); if (!r) return '';
      for (var n = 0; n < names.length; n++) {
        var v = norm(String(names[n] || '').replace(/^(provincia|comuna) de /i, ''));
        if (!v) continue;
        for (var i = 0; i < r[2].length; i++) if (norm(r[2][i]) === v) return r[2][i];
      }
      return '';
    }

    /* Listas de región y comuna */
    REG.forEach(function (r) { var o = document.createElement('option'); o.value = r[0]; o.textContent = r[1]; fReg.appendChild(o); });
    function fillComunas(code, selected) {
      fCom.innerHTML = '';
      var r = regionOf(code);
      var first = document.createElement('option'); first.value = ''; first.textContent = r ? 'Elige tu comuna' : 'Primero elige región';
      fCom.appendChild(first);
      fCom.disabled = !r;
      if (!r) return;
      r[2].slice().sort(function (a, b) { return a.localeCompare(b, 'es'); }).forEach(function (c) {
        var o = document.createElement('option'); o.value = c; o.textContent = c; if (c === selected) o.selected = true; fCom.appendChild(o);
      });
    }
    fReg.addEventListener('change', function () { fillComunas(fReg.value, ''); verified = false; warned = false; });
    fCom.addEventListener('change', function () { verified = false; warned = false; });

    /* Autocompletado con el mapa (Photon / OpenStreetMap, solo Chile) */
    var cache = {};
    function photon(q, cb) {
      var ck = norm(q);
      if (cache[ck]) { cb(cache[ck]); return; }
      var url = 'https://photon.komoot.io/api/?limit=8&bbox=-76,-56.5,-66,-17.4&q=' + encodeURIComponent(q);
      fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        var out = [];
        (j.features || []).forEach(function (f) {
          var p = f.properties || {};
          if (p.countrycode && p.countrycode !== 'CL') return;
          var street = p.street || (p.type === 'street' ? p.name : '');
          if (!street) return;
          var code = stateToCode(p.state);
          var comuna = findComuna(code, [p.city, p.district, p.locality, p.county, p.name]);
          var key = norm(street + '|' + (p.housenumber || '') + '|' + comuna);
          if (out.some(function (o) { return o.key === key; })) return;
          out.push({ key: key, street: street, number: p.housenumber || '', code: code, comuna: comuna, city: p.city || p.county || '' });
        });
        cache[ck] = out;
        cb(out);
      }).catch(function () { cb(null); });
    }
    function renderSug(list) {
      results = list || []; active = -1; sug.innerHTML = '';
      if (list === null) { sug.hidden = true; return; }
      if (!results.length) {
        sug.innerHTML = '<li class="beam-addr__sug-info">No encontramos esa calle en el mapa. Revisa cómo se escribe, o complétala a mano y elige región y comuna.</li>';
        sug.hidden = false; return;
      }
      results.forEach(function (r, i) {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        var reg = regionOf(r.code);
        li.innerHTML = '';
        li.appendChild(document.createTextNode(r.street + (r.number ? ' ' + r.number : '')));
        var sm = document.createElement('small');
        sm.textContent = [r.comuna || r.city, reg ? reg[1] : ''].filter(Boolean).join(', ');
        li.appendChild(sm);
        li.addEventListener('mousedown', function (e) { e.preventDefault(); pick(i); });
        sug.appendChild(li);
      });
      sug.hidden = false;
    }
    function pick(i) {
      var r = results[i]; if (!r) return;
      fStreet.value = r.street + (r.number ? ' ' + r.number : ' ');
      if (r.code) { fReg.value = r.code; fillComunas(r.code, r.comuna); }
      sug.hidden = true;
      verified = !!(r.number && r.code && r.comuna);
      warned = false;
      setMsg('', false);
      [fStreet, fReg, fCom].forEach(function (el) { el.classList.remove('is-bad'); });
      if (!r.number) {
        fStreet.focus();
        fStreet.setSelectionRange(fStreet.value.length, fStreet.value.length);
        setMsg('Escribe el número de tu casa o edificio al final de la calle.', false);
      }
      else if (!r.comuna) { fCom.focus(); setMsg('Elige tu comuna de la lista.', false); }
      else fExtra.focus();
    }
    fStreet.addEventListener('input', function () {
      verified = false; warned = false;
      clearTimeout(timer);
      var q = fStreet.value.trim();
      if (q.length < 4) { sug.hidden = true; return; }
      /* Aviso inmediato mientras responde el mapa (si aún no hay sugerencias a la vista) */
      if (sug.hidden || !results.length) {
        results = []; active = -1;
        sug.innerHTML = '<li class="beam-addr__sug-info">🔎 Buscando direcciones en el mapa…</li>';
        sug.hidden = false;
      }
      timer = setTimeout(function () {
        var my = ++reqId;
        var extra = fCom.value ? ', ' + fCom.value : '';
        /* Se muestra cualquier respuesta más nueva que la que está a la vista: si el mapa demora,
           aparecen antes las sugerencias de lo escrito hasta ese momento */
        photon(q + extra, function (list) {
          if (my <= shownId || !fStreet.value.trim() || document.activeElement !== fStreet) return;
          if (list === null && my !== reqId) return;
          shownId = my;
          renderSug(list);
        });
      }, 250);
    });
    fStreet.addEventListener('keydown', function (e) {
      if (sug.hidden || !results.length) return;
      var items = sug.querySelectorAll('li');
      if (e.key === 'ArrowDown') { e.preventDefault(); active = Math.min(active + 1, items.length - 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); active = Math.max(active - 1, 0); }
      else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); pick(active); return; }
      else if (e.key === 'Escape') { sug.hidden = true; return; }
      else return;
      items.forEach(function (li, i) { li.classList.toggle('is-active', i === active); });
    });
    fStreet.addEventListener('blur', function () { setTimeout(function () { sug.hidden = true; }, 150); });

    function setMsg(t, ok) { msg.textContent = t; msg.classList.toggle('is-ok', !!ok); }

    /* Abrir / cerrar */
    function open(t) {
      target = t;
      try {
        var saved = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
        if (saved && !fEmail.value && saved.email) fEmail.value = saved.email;
        if (saved && !fPhone.value && saved.phone) fPhone.value = saved.phone;
        if (saved && !fFirst.value && saved.first) fFirst.value = saved.first;
        if (saved && !fLast.value && saved.last) fLast.value = saved.last;
        if (saved && !fStreet.value) {
          fStreet.value = [saved.street, saved.number].filter(Boolean).join(' '); fExtra.value = saved.extra || '';
          if (saved.region) { fReg.value = saved.region; fillComunas(saved.region, saved.comuna); }
          verified = !!saved.verified;
        }
      } catch (e) {}
      setMsg('', false); btn.disabled = false;
      if (!root.open) { try { root.showModal(); } catch (err) { root.setAttribute('open', ''); } }
      setTimeout(function () {
        var empty = [fEmail, fPhone, fFirst, fLast, fStreet].filter(function (el) { return !el.value.trim(); })[0];
        (empty || btn).focus();
      }, 50);
    }
    function close() { try { root.close(); } catch (err) { root.removeAttribute('open'); } target = null; }
    root.addEventListener('cancel', function (e) { e.preventDefault(); }); /* Escape no la cierra */
    /* Solo se cierra con la X (un clic afuera o Escape no la cierran, para no perder lo escrito) */
    root.addEventListener('click', function (e) { if (e.target.closest('.beam-addr__x')) close(); });

    /* Enviar al checkout con la dirección ya llenada */
    function goCheckout(addr) {
      function build(lines, extraParams) {
        var p = [];
        p.push('checkout[email]=' + encodeURIComponent(addr.email));
        p.push('checkout[shipping_address][country]=CL');
        p.push('checkout[shipping_address][first_name]=' + encodeURIComponent(addr.first));
        p.push('checkout[shipping_address][last_name]=' + encodeURIComponent(addr.last));
        p.push('checkout[shipping_address][phone]=' + encodeURIComponent('+56' + addr.phone));
        p.push('checkout[shipping_address][address1]=' + encodeURIComponent(addr.street + ' ' + addr.number));
        if (addr.extra) p.push('checkout[shipping_address][address2]=' + encodeURIComponent(addr.extra));
        p.push('checkout[shipping_address][city]=' + encodeURIComponent(addr.comuna));
        p.push('checkout[shipping_address][province]=' + encodeURIComponent(addr.region));
        (extraParams || []).forEach(function (x) { p.push(x); });
        return '/cart/' + lines.join(',') + '?' + p.join('&');
      }
      if (target && target.type === 'buy') {
        location.href = build([target.variant + ':' + target.qty]);
        return;
      }
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart.items || !cart.items.length) { location.href = '/checkout'; return; }
        var qty = {};
        cart.items.forEach(function (it) { qty[it.variant_id] = (qty[it.variant_id] || 0) + it.quantity; });
        var lines = Object.keys(qty).map(function (v) { return v + ':' + qty[v]; });
        var extra = [];
        var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable !== false; }).map(function (d) { return d.code; });
        if (codes.length) extra.push('discount=' + encodeURIComponent(codes.join(',')));
        if (cart.note) extra.push('note=' + encodeURIComponent(cart.note));
        location.href = build(lines, extra);
      }).catch(function () { location.href = '/checkout'; });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var sn = splitNum(fStreet.value);
      var addr = { email: fEmail.value.trim(), phone: phoneDigits(fPhone.value), first: fFirst.value.trim(), last: fLast.value.trim(), street: sn.street, number: sn.number, extra: fExtra.value.trim(), region: fReg.value, comuna: fCom.value };
      var bad = [];
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr.email)) bad.push(fEmail);
      if (!/^\d{9}$/.test(addr.phone)) bad.push(fPhone);
      if (!addr.first) bad.push(fFirst);
      if (!addr.last) bad.push(fLast);
      if (addr.street.length < 3 || !addr.number) bad.push(fStreet);
      if (!addr.region) bad.push(fReg);
      if (!addr.comuna) bad.push(fCom);
      [fEmail, fPhone, fFirst, fLast, fStreet, fReg, fCom].forEach(function (el) { el.classList.toggle('is-bad', bad.indexOf(el) !== -1); });
      if (bad.length) {
        var only = bad.length === 1 ? bad[0] : null;
        setMsg(only === fStreet && addr.street.length >= 3 ? 'Falta el número: escríbelo al final de la calle (ej: Barros Arana 1548).'
          : only === fEmail && addr.email ? 'Revisa tu correo electrónico (ej: nombre@gmail.com).'
          : only === fPhone && addr.phone ? 'Revisa tu teléfono: son 9 dígitos (ej: 9 1234 5678).'
          : 'Completa los campos marcados en rojo.', false);
        bad[0].focus(); return;
      }

      function proceed(isVerified) {
        try { if (!fSave.checked) localStorage.removeItem(LS_KEY); else localStorage.setItem(LS_KEY, JSON.stringify({ email: addr.email, phone: addr.phone, first: addr.first, last: addr.last, street: addr.street, number: addr.number, extra: addr.extra, region: addr.region, comuna: addr.comuna, verified: isVerified })); } catch (err) {}
        setMsg('✓ Dirección lista. Te llevamos al pago…', true);
        btn.disabled = true;
        goCheckout(addr);
      }
      if (verified || warned) { proceed(verified); return; }

      /* Escrita a mano: se intenta confirmar en el mapa (primero con lo ya buscado, sin esperar) */
      function matches(list) {
        return (list || []).some(function (r) {
          return r.code === addr.region && norm(r.comuna) === norm(addr.comuna) && norm(r.number) === norm(addr.number) && norm(r.street).indexOf(norm(addr.street).replace(/^(calle|avenida|av\.?|pasaje|psje\.?) /, '')) !== -1;
        });
      }
      if (Object.keys(cache).some(function (k) { return matches(cache[k]); })) { verified = true; proceed(true); return; }
      btn.disabled = true; setMsg('Verificando tu dirección en el mapa…', true);
      photon(addr.street + ' ' + addr.number + ', ' + addr.comuna, function (list) {
        btn.disabled = false;
        if (matches(list)) { verified = true; proceed(true); return; }
        warned = true;
        setMsg('⚠️ No pudimos confirmar "' + addr.street + ' ' + addr.number + ', ' + addr.comuna + '" en el mapa. Revisa que esté bien escrita. Si es correcta, presiona "Continuar al pago" otra vez.', false);
      });
    });

    /* Interceptar botones de pago */
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var buy = e.target.closest('.shopify-payment-button__button, shopify-buy-it-now-button button');
      if (buy) {
        var pf = buy.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
        var vid = pf && pf.querySelector('[name="id"]');
        if (!vid || !vid.value) return;
        var q = pf.querySelector('[name="quantity"]') || document.querySelector('input[name="quantity"]');
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        open({ type: 'buy', variant: vid.value, qty: Math.max(1, parseInt(q && q.value, 10) || 1) });
        return;
      }
      var co = e.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href$="/checkout"]');
      if (!co || root.contains(co)) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      open({ type: 'cart' });
    }, true);
    document.addEventListener('submit', function (e) {
      var s = e.submitter;
      if (s && s.name === 'checkout' && !root.contains(s)) { e.preventDefault(); e.stopImmediatePropagation(); open({ type: 'cart' }); }
    }, true);

    window.beamAddrOpen = open;
  })();
